module.exports = __webpack_public_path__ + "img/hero-lg.7722f893.png";